import { Component, Input } from "@angular/core";

import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-confirm-modal-content",
  template: `
    <div class="modal-header">
      <h5 class="modal-title">{{ title }}</h5>
      <div *ngIf="displayCornerClose">
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="modal-body">
      <div *ngIf="bodyText.length; else: default">
        <p *ngFor="let line of bodyText" class="text-center legal-info">
          {{ line }}
        </p>
      </div>
      <ng-template #default>
        <p *ngFor="let line of bodyText" class="text-center legal-info">
          {{ bodyText }}
        </p>
      </ng-template>
    </div>
    <div class="modal-footer">
      <span class="clickable" (click)="activeModal.dismiss('Cancel')">{{
        cancelButtonText
      }}</span>
      <button
        type="button"
        class="btn square-btn"
        (click)="activeModal.close('Okay')"
      >
        {{ successButtonText }}
      </button>
    </div>
    <div *ngIf="note" class="note">
      * Clicking PROCEED will continue creating a new patient record.
    </div>
  `,
  styleUrls: ["./confirm-modal.component.scss"]
})
export class ConfirmModalContentComponent {
  @Input() title: string;
  @Input() bodyText: any;
  @Input() cancelButtonText: string = "Cancel";
  @Input() successButtonText: string = "Okay";
  @Input() displayCornerClose: boolean = true;
  @Input() note?: boolean = false;

  constructor(public activeModal: NgbActiveModal) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/confirm-modal/confirm-modal.component.ts